import { validateOwnerData } from 'registration/actions/validate-owner-data.actions';
import template from './chain-head.html';

const mapStateToThis = ({ registration, config }) => {
  const { ownerData } = registration;
  const { phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength, registrationLockoutPeriodMinutes } = config;

  return {
    ownerData,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    registrationLockoutPeriodMinutes,
  };
};

const mapDispatchToThis = {
  validateOwnerData,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Responsive')
class SelfRegistrationRetailerChainHeadController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.clearRegistrationForm();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async checkEmail(form) {
    const { email } = form;

    if (email.$pristine) return;

    this.isLoading = true;
    await this.validateOwnerData(this.formModel);
    this.isLoading = false;

    email.$setValidity('blocked-email', !this.ownerData.blocked);
    email.$setValidity('email-invalid', this.ownerData.validPin);
  }
}

export default class SelfRegistrationRetailerChainHeadComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationRetailerChainHeadController;
    this.bindings = {
      form: '=',
      formModel: '=',
      clearRegistrationForm: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/chain-head/chain-head-component.js